module.exports = __webpack_public_path__ + "img/album14_32.65ceb52a.jpg";